module.exports = __webpack_public_path__ + "img/icon_1_35.352f29c9.png";